module.exports = __webpack_public_path__ + "static/media/eye.a70e7459.png";